var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaregivingGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M126.71,23.28a33,33,0,0,0-46.71,0A33,33,0,0,0,33.29,70L80,116.7,126.71,70A33,33,0,0,0,126.71,23.28Z",
    fill: "#d1f0ff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.06,105.86l1.38-12.71L51,77.57l-4.38-6.08-1.47-8.15,3.3-12s-2.26-4.39-4.78-3.71l1.14-3.28s-.93-5.56-4-4.94A6.26,6.26,0,0,0,38,41.05c-.35-1.54-1.13-3.27-2.87-3.2s-3.85,1.61-5.71,3.4a2,2,0,0,0-1.82-.94c-4,.16-9.91,8.54-9.91,8.54l-4.57,13L15.56,90l9.26,12.66,7.58,8L34,120.32,59.06,116Z",
    fill: "#d9ac62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3,82.13l-1.21-18s4.28-4.2,7-1.18c2.94,3.32,4.39,14,6.74,16.59a92,92,0,0,1,7.76,10.3l7.58,1.53",
    fill: "none",
    stroke: "#805a20",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "43.59 47.85 40.21 53.12 38.54 61.98 40.23 72.75",
    fill: "none",
    stroke: "#805a20",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "2 4 24 3 18 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,105.86l1.38-12.71L51,77.57l-4.38-6.08-1.47-8.15,3.3-12s-2.26-4.39-4.78-3.71l1.14-3.28s-.93-5.56-4-4.94A6.28,6.28,0,0,0,38,41.06c-.35-1.54-1.12-3.28-2.87-3.21s-3.85,1.61-5.71,3.4a2,2,0,0,0-1.82-.94c-4,.16-9.91,8.54-9.91,8.54l-4.57,13L15.56,90l9.26,12.66,7.58,8L34,120.32,59.06,116Z",
    fill: "none",
    stroke: "#805a20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.64 135.09 30.71 115 64.29 112.75 66.89 135.09",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.53,
    y1: 115,
    x2: 29.92,
    y2: 122.7,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.29,
    y1: 112.74,
    x2: 66.89,
    y2: 135.09,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "10 3 3 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.71,
    y1: 115,
    x2: 64.29,
    y2: 112.74,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "37.93 41.13 38.29 43.36 33.31 51.1 31.42 62.13 34.28 73.55",
    fill: "none",
    stroke: "#805a20",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "2 4 24 3 18 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.29,41.06c1.23,1.42,1.24,4.37,1.24,4.37l-3.94,6.79-2.5,9.59",
    fill: "none",
    stroke: "#805a20",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "2 4 24 3 18 4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.63,105.86l-1.38-12.71,7.45-15.58,4.37-6.08,1.47-8.15-3.3-12s2.26-4.39,4.78-3.71l-1.13-3.28s.93-5.56,4-4.94a6.28,6.28,0,0,1,2.82,1.67c.34-1.54,1.12-3.27,2.86-3.2s3.85,1.61,5.71,3.4a2,2,0,0,1,1.82-.94c4,.16,9.92,8.54,9.92,8.54l4.56,13L144.14,90l-9.27,12.66-7.58,8-1.55,9.65L100.63,116Z",
    fill: "#d9ac62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4,82.13l1.2-18s-4.28-4.2-6.95-1.18c-2.94,3.32-4.39,14-6.74,16.59a92,92,0,0,0-7.76,10.3l-7.58,1.53",
    fill: "none",
    stroke: "#805a20",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "116.11 47.85 119.49 53.12 121.15 61.98 119.46 72.75",
    fill: "none",
    stroke: "#805a20",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "2 4 24 3 18 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63,105.86l-1.38-12.71,7.45-15.58,4.37-6.08,1.47-8.15-3.3-12s2.26-4.39,4.78-3.71l-1.13-3.28s.93-5.56,4-4.94a6.28,6.28,0,0,1,2.81,1.68c.35-1.54,1.13-3.28,2.87-3.21s3.85,1.61,5.71,3.4a2.05,2.05,0,0,1,1.82-.94c4,.16,9.92,8.54,9.92,8.54l4.56,13L144.14,90l-9.27,12.66-7.58,8-1.55,9.65L100.63,116Z",
    fill: "none",
    stroke: "#805a20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "131.05 135.09 128.98 115 95.4 112.75 92.8 135.09",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.4,
    y1: 112.74,
    x2: 92.8,
    y2: 135.09,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "10 3 3 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.98,
    y1: 115,
    x2: 95.4,
    y2: 112.74,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "121.77 41.13 121.4 43.36 126.38 51.1 128.27 62.13 125.41 73.55",
    fill: "none",
    stroke: "#805a20",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "2 4 24 3 18 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,41.06c-1.23,1.42-1.24,4.37-1.24,4.37l3.94,6.79,2.5,9.59",
    fill: "none",
    stroke: "#805a20",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "2 4 24 3 18 4"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "102.63 52.82 89.05 52.82 89.05 39.24 70.95 39.24 70.95 52.82 57.37 52.82 57.37 70.93 70.95 70.93 70.95 84.51 89.05 84.51 89.05 70.93 102.63 70.93 102.63 52.82",
    fill: "#0af"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.98,
    y1: 115,
    x2: 129.98,
    y2: 122.7,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregivingGoal);
export default __webpack_public_path__ + "static/media/caregiving-goal.de3b9431.svg";
export { ForwardRef as ReactComponent };